<template>
    <div class="ds-search-field">
        <input type="text"
            class="ds-search-input min-w-full max-w-lg" :value="modelValue"
            @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
            placeholder="Поиск..." maxlength="100">
        <div class="absolute top-0 right-0 text-grayicon w-10 h-10 flex items-center justify-center">
            <icon width="16" height="16" v-if="!modelValue">
                <IconSearch />
            </icon> 
            <icon v-else="modelValue" class="cursor-pointer" @click="$emit('clear')">
                <IconClose />
            </icon> 
        </div> 
    </div>
</template>

<script setup lang="ts">
import IconClose from '@/ui/icons/IconClose.vue';
import IconSearch from '@/ui/icons/IconSearch.vue'

defineProps({
    modelValue: {
        type: String,
        default: ''
    }
})
defineEmits(['update:modelValue', 'clear'])

</script>
